webpackJsonp([277423997445353],{

/***/ 220:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _banner = __webpack_require__(9);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Disclaimer = function (_Component) {
	  _inherits(Disclaimer, _Component);
	
	  function Disclaimer() {
	    _classCallCheck(this, Disclaimer);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Disclaimer.prototype.render = function render() {
	    var pageContent = this.props.data.contentfulPageContent;
	    return _react2.default.createElement(
	      "div",
	      { id: "page-wrapper" },
	      _react2.default.createElement(
	        "section",
	        { className: "main alt" },
	        _react2.default.createElement(
	          "header",
	          null,
	          _react2.default.createElement(
	            "h1",
	            null,
	            pageContent.title
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "inner style2" },
	          _react2.default.createElement("span", { dangerouslySetInnerHTML: { __html: pageContent.content.childMarkdownRemark.html } })
	        )
	      )
	    );
	  };
	
	  return Disclaimer;
	}(_react.Component);
	
	exports.default = Disclaimer;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-disclaimer-js-f012ce29c15c0a2faebe.js